// ** Initial State
const initialState = {
  connections: [],
  connections_total: 0,
};

const simPhoneConnections = (state = initialState, action) => {
  switch (action.type) {
    case "GET_ALL_SIM_PHONE_CONNECTIONS":
      return {
        ...state,
        connections: action.data,
        connections_total: action.total,
      };
    default:
      return { ...state };
  }
};
export default simPhoneConnections;
